import { DeskDam } from 'client/api/backend/schemas';
import { registerToolkitObjectType } from 'client/components/toolkit/objects/registerToolkitObjectType';

export const DamToolkitObject = registerToolkitObjectType<DeskDam>('dam');
